export type ArchiveAction = "archive" | "restore" | "purge";

export interface ArchiveConfirmCopy {
  title: string;
  message: string;
  confirmLabel: string;
}

const plural = (n: number, word: string) => `${word}${n === 1 ? "" : "s"}`;

const LABELS: Record<ArchiveAction, string> = {
  archive: "Archive",
  restore: "Unarchive",
  purge: "Purge",
};

const PAST: Record<ArchiveAction, string> = {
  archive: "archived",
  restore: "unarchived",
  purge: "purged",
};

const BODIES: Record<ArchiveAction, string> = {
  archive: "Archiving projects can be undone later from the Archived tab.",
  restore: "These projects will be moved back to the active tabs.",
  purge: "These projects will be permanently deleted. This can't be undone.",
};

const changeOrderClause = (action: ArchiveAction, m: number): string => {
  const cos = `${m} ${plural(m, "change request")}`;
  if (action === "archive") return `This also archives ${cos}.`;
  if (action === "restore") return `Their ${cos} will be restored too.`;
  return `${cos} will be permanently deleted too.`;
};

export const archiveConfirmCopy = (
  action: ArchiveAction,
  projects: number,
  changeOrders: number
): ArchiveConfirmCopy => ({
  title: `${LABELS[action]} ${projects} ${plural(projects, "Project")}?`,
  message:
    changeOrders > 0
      ? `${BODIES[action]} ${changeOrderClause(action, changeOrders)}`
      : BODIES[action],
  confirmLabel: LABELS[action],
});

export const archiveSuccessText = (action: ArchiveAction, projects: number) =>
  `${projects} ${plural(projects, "project")} ${PAST[action]}.`;

export const archiveFailureHeadline = (
  action: ArchiveAction,
  failed: number,
  total: number
) => `Couldn't ${LABELS[action].toLowerCase()} ${failed} of ${total} projects.`;
